var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "share-btns" }, [
    _c("i", {
      staticClass: "fab fa-facebook",
      attrs: { "data-id": _vm.id, "data-label": "Facebook" },
      on: {
        click: function ($event) {
          return _vm.share("facebook")
        },
      },
    }),
    _vm._v(" "),
    _c("i", {
      staticClass: "fab fa-whatsapp",
      attrs: { "data-id": _vm.id, "data-label": "Whatsapp" },
      on: {
        click: function ($event) {
          return _vm.share("whatsapp")
        },
      },
    }),
    _vm._v(" "),
    _c("i", {
      staticClass: "far fa-envelope",
      attrs: { "data-id": _vm.id, "data-label": "Email" },
      on: {
        click: function ($event) {
          return _vm.share("email")
        },
      },
    }),
    _vm._v(" "),
    _c("i", {
      staticClass: "fas fa-link",
      attrs: { "data-id": _vm.id, "data-label": "Link" },
      on: {
        click: function ($event) {
          return _vm.share("copy")
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }